import { FactionLeaderboardRank } from '@wwe-portal/entities/leaderboard.type';
import { FC } from 'react';
import { FactionLeaderboard } from './faction-leaderboard';
import { LeaderboardHead } from './leaderboard-head';
import { formatDateTime } from '@wwe-portal/utils/date';

export const FactionLeaderboardBlock: FC<{
  leaderboard: {
    eventId: string;
    isLive: boolean;
    name: string;
    endDate: string;
    factions: FactionLeaderboardRank[];
  };
  moreHref: string;
}> = ({ leaderboard, moreHref }) => {
  const header = (
    <LeaderboardHead
      isLive={leaderboard.isLive}
      name={leaderboard.name}
      moreHref={moreHref}
      moreText="See Top 500"
    />
  );
  return (
    <div>
      <FactionLeaderboard
        data={leaderboard.factions.map((faction) => ({
          points: faction.factionPoints,
          rank: faction.factionRank,
          factionId: faction.factionId,
          faction: faction.factionName,
          name: faction.factionName,
        }))}
        mobileHeader={header}
        desktopHeader={header}
        containerClassname="min-h-[936px]"
      />
      <div className="text-text600 mt-4 text-xs font-medium">
        {leaderboard.isLive ? null : (
          <>Ended on {formatDateTime(leaderboard.endDate, 'DD')}</>
        )}
      </div>
    </div>
  );
};
